// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutHadleyEnergySolutionsRouteImport } from './routes/about-hadley-energy-solutions'
import { Route as AboutUsRouteImport } from './routes/about-us'
import { Route as CommercialElectricalRouteImport } from './routes/commercial-electrical'
import { Route as CommercialElectricalServicesRouteImport } from './routes/commercial-electrical-services'
import { Route as CommercialHvacRouteImport } from './routes/commercial-hvac'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ContactUsRouteImport } from './routes/contact-us'
import { Route as EnergyAuditRouteImport } from './routes/energy-audit'
import { Route as HvacMaintenanceRouteImport } from './routes/hvac-maintenance'
import { Route as HvacMaintenanceLouisvilleKyRouteImport } from './routes/hvac-maintenance-louisville-ky'
import { Route as PortfolioRouteImport } from './routes/portfolio'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as RequestEstimateRouteImport } from './routes/request-estimate'
import { Route as ReviewsRouteImport } from './routes/reviews'
import { Route as SamplePageRouteImport } from './routes/sample-page'
import { Route as ServiceAreasRouteImport } from './routes/service-areas'
import { Route as SitemapRouteImport } from './routes/sitemap'
import { Route as XmlrpcDotphpRouteImport } from './routes/xmlrpc[.]php'
import { Route as R2023SplatRouteImport } from './routes/2023/$'
import { Route as AboutIndexRouteImport } from './routes/about/index'
import { Route as AboutCareersRouteImport } from './routes/about/careers'
import { Route as AboutFaqRouteImport } from './routes/about/faq'
import { Route as AboutSafetyRouteImport } from './routes/about/safety'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminCallReportRouteImport } from './routes/admin/call-report'
import { Route as AdminCompetitorsRouteImport } from './routes/admin/competitors'
import { Route as AdminDashboardRouteImport } from './routes/admin/dashboard'
import { Route as AdminForgotPasswordRouteImport } from './routes/admin/forgot-password'
import { Route as AdminLeadsRouteImport } from './routes/admin/leads'
import { Route as AdminProjectsRouteImport } from './routes/admin/projects'
import { Route as AdminSeoRouteImport } from './routes/admin/seo'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminSignupRouteImport } from './routes/admin/signup'
import { Route as AdminSpamDebugRouteImport } from './routes/admin/spam-debug'
import { Route as AdminSpamVariantsRouteImport } from './routes/admin/spam-variants'
import { Route as AdminTrafficRouteImport } from './routes/admin/traffic'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AuthorSplatRouteImport } from './routes/author/$'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as CategorySplatRouteImport } from './routes/category/$'
import { Route as ElectricalServicesIndexRouteImport } from './routes/electrical-services/index'
import { Route as ElectricalServicesSlugRouteImport } from './routes/electrical-services/$slug'
import { Route as EnergyManagementIndexRouteImport } from './routes/energy-management/index'
import { Route as EnergyManagementSlugRouteImport } from './routes/energy-management/$slug'
import { Route as FeedIndexRouteImport } from './routes/feed/index'
import { Route as FeedSplatRouteImport } from './routes/feed/$'
import { Route as GuideSlugRouteImport } from './routes/guide/$slug'
import { Route as HvacServicesIndexRouteImport } from './routes/hvac-services/index'
import { Route as HvacServicesSlugRouteImport } from './routes/hvac-services/$slug'
import { Route as IndustriesIndexRouteImport } from './routes/industries/index'
import { Route as IndustriesSlugRouteImport } from './routes/industries/$slug'
import { Route as LouisvilleKyIndexRouteImport } from './routes/louisville-ky/index'
import { Route as LouisvilleKySplatRouteImport } from './routes/louisville-ky/$'
import { Route as PageSplatRouteImport } from './routes/page/$'
import { Route as ServiceAreaIndexRouteImport } from './routes/service-area/index'
import { Route as ServiceAreaSlugRouteImport } from './routes/service-area/$slug'
import { Route as ServicesSplatRouteImport } from './routes/services/$'
import { Route as StadiumLightingIndexRouteImport } from './routes/stadium-lighting/index'
import { Route as StadiumLightingSlugRouteImport } from './routes/stadium-lighting/$slug'
import { Route as StadiumSportsLightingIndexRouteImport } from './routes/stadium-sports-lighting/index'
import { Route as StadiumSportsLightingSlugRouteImport } from './routes/stadium-sports-lighting/$slug'
import { Route as TagSplatRouteImport } from './routes/tag/$'
import { Route as WpAdminSplatRouteImport } from './routes/wp-admin/$'
import { Route as WpContentSplatRouteImport } from './routes/wp-content/$'
import { Route as WpIncludesSplatRouteImport } from './routes/wp-includes/$'
import { Route as WpJsonSplatRouteImport } from './routes/wp-json/$'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutHadleyEnergySolutionsRoute = AboutHadleyEnergySolutionsRouteImport.update({
            id: '/about-hadley-energy-solutions',path: '/about-hadley-energy-solutions',getParentRoute: () => rootRouteImport
          })
const AboutUsRoute = AboutUsRouteImport.update({
            id: '/about-us',path: '/about-us',getParentRoute: () => rootRouteImport
          })
const CommercialElectricalRoute = CommercialElectricalRouteImport.update({
            id: '/commercial-electrical',path: '/commercial-electrical',getParentRoute: () => rootRouteImport
          })
const CommercialElectricalServicesRoute = CommercialElectricalServicesRouteImport.update({
            id: '/commercial-electrical-services',path: '/commercial-electrical-services',getParentRoute: () => rootRouteImport
          })
const CommercialHvacRoute = CommercialHvacRouteImport.update({
            id: '/commercial-hvac',path: '/commercial-hvac',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ContactUsRoute = ContactUsRouteImport.update({
            id: '/contact-us',path: '/contact-us',getParentRoute: () => rootRouteImport
          })
const EnergyAuditRoute = EnergyAuditRouteImport.update({
            id: '/energy-audit',path: '/energy-audit',getParentRoute: () => rootRouteImport
          })
const HvacMaintenanceRoute = HvacMaintenanceRouteImport.update({
            id: '/hvac-maintenance',path: '/hvac-maintenance',getParentRoute: () => rootRouteImport
          })
const HvacMaintenanceLouisvilleKyRoute = HvacMaintenanceLouisvilleKyRouteImport.update({
            id: '/hvac-maintenance-louisville-ky',path: '/hvac-maintenance-louisville-ky',getParentRoute: () => rootRouteImport
          })
const PortfolioRoute = PortfolioRouteImport.update({
            id: '/portfolio',path: '/portfolio',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const RequestEstimateRoute = RequestEstimateRouteImport.update({
            id: '/request-estimate',path: '/request-estimate',getParentRoute: () => rootRouteImport
          })
const ReviewsRoute = ReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => rootRouteImport
          })
const SamplePageRoute = SamplePageRouteImport.update({
            id: '/sample-page',path: '/sample-page',getParentRoute: () => rootRouteImport
          })
const ServiceAreasRoute = ServiceAreasRouteImport.update({
            id: '/service-areas',path: '/service-areas',getParentRoute: () => rootRouteImport
          })
const SitemapRoute = SitemapRouteImport.update({
            id: '/sitemap',path: '/sitemap',getParentRoute: () => rootRouteImport
          })
const XmlrpcDotphpRoute = XmlrpcDotphpRouteImport.update({
            id: '/xmlrpc.php',path: '/xmlrpc.php',getParentRoute: () => rootRouteImport
          })
const R2023SplatRoute = R2023SplatRouteImport.update({
            id: '/2023/$',path: '/2023/$',getParentRoute: () => rootRouteImport
          })
const AboutIndexRoute = AboutIndexRouteImport.update({
            id: '/about/',path: '/about/',getParentRoute: () => rootRouteImport
          })
const AboutCareersRoute = AboutCareersRouteImport.update({
            id: '/about/careers',path: '/about/careers',getParentRoute: () => rootRouteImport
          })
const AboutFaqRoute = AboutFaqRouteImport.update({
            id: '/about/faq',path: '/about/faq',getParentRoute: () => rootRouteImport
          })
const AboutSafetyRoute = AboutSafetyRouteImport.update({
            id: '/about/safety',path: '/about/safety',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const AdminCallReportRoute = AdminCallReportRouteImport.update({
            id: '/admin/call-report',path: '/admin/call-report',getParentRoute: () => rootRouteImport
          })
const AdminCompetitorsRoute = AdminCompetitorsRouteImport.update({
            id: '/admin/competitors',path: '/admin/competitors',getParentRoute: () => rootRouteImport
          })
const AdminDashboardRoute = AdminDashboardRouteImport.update({
            id: '/admin/dashboard',path: '/admin/dashboard',getParentRoute: () => rootRouteImport
          })
const AdminForgotPasswordRoute = AdminForgotPasswordRouteImport.update({
            id: '/admin/forgot-password',path: '/admin/forgot-password',getParentRoute: () => rootRouteImport
          })
const AdminLeadsRoute = AdminLeadsRouteImport.update({
            id: '/admin/leads',path: '/admin/leads',getParentRoute: () => rootRouteImport
          })
const AdminProjectsRoute = AdminProjectsRouteImport.update({
            id: '/admin/projects',path: '/admin/projects',getParentRoute: () => rootRouteImport
          })
const AdminSeoRoute = AdminSeoRouteImport.update({
            id: '/admin/seo',path: '/admin/seo',getParentRoute: () => rootRouteImport
          })
const AdminSettingsRoute = AdminSettingsRouteImport.update({
            id: '/admin/settings',path: '/admin/settings',getParentRoute: () => rootRouteImport
          })
const AdminSignupRoute = AdminSignupRouteImport.update({
            id: '/admin/signup',path: '/admin/signup',getParentRoute: () => rootRouteImport
          })
const AdminSpamDebugRoute = AdminSpamDebugRouteImport.update({
            id: '/admin/spam-debug',path: '/admin/spam-debug',getParentRoute: () => rootRouteImport
          })
const AdminSpamVariantsRoute = AdminSpamVariantsRouteImport.update({
            id: '/admin/spam-variants',path: '/admin/spam-variants',getParentRoute: () => rootRouteImport
          })
const AdminTrafficRoute = AdminTrafficRouteImport.update({
            id: '/admin/traffic',path: '/admin/traffic',getParentRoute: () => rootRouteImport
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/admin/users',path: '/admin/users',getParentRoute: () => rootRouteImport
          })
const AuthorSplatRoute = AuthorSplatRouteImport.update({
            id: '/author/$',path: '/author/$',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const CategorySplatRoute = CategorySplatRouteImport.update({
            id: '/category/$',path: '/category/$',getParentRoute: () => rootRouteImport
          })
const ElectricalServicesIndexRoute = ElectricalServicesIndexRouteImport.update({
            id: '/electrical-services/',path: '/electrical-services/',getParentRoute: () => rootRouteImport
          })
const ElectricalServicesSlugRoute = ElectricalServicesSlugRouteImport.update({
            id: '/electrical-services/$slug',path: '/electrical-services/$slug',getParentRoute: () => rootRouteImport
          })
const EnergyManagementIndexRoute = EnergyManagementIndexRouteImport.update({
            id: '/energy-management/',path: '/energy-management/',getParentRoute: () => rootRouteImport
          })
const EnergyManagementSlugRoute = EnergyManagementSlugRouteImport.update({
            id: '/energy-management/$slug',path: '/energy-management/$slug',getParentRoute: () => rootRouteImport
          })
const FeedIndexRoute = FeedIndexRouteImport.update({
            id: '/feed/',path: '/feed/',getParentRoute: () => rootRouteImport
          })
const FeedSplatRoute = FeedSplatRouteImport.update({
            id: '/feed/$',path: '/feed/$',getParentRoute: () => rootRouteImport
          })
const GuideSlugRoute = GuideSlugRouteImport.update({
            id: '/guide/$slug',path: '/guide/$slug',getParentRoute: () => rootRouteImport
          })
const HvacServicesIndexRoute = HvacServicesIndexRouteImport.update({
            id: '/hvac-services/',path: '/hvac-services/',getParentRoute: () => rootRouteImport
          })
const HvacServicesSlugRoute = HvacServicesSlugRouteImport.update({
            id: '/hvac-services/$slug',path: '/hvac-services/$slug',getParentRoute: () => rootRouteImport
          })
const IndustriesIndexRoute = IndustriesIndexRouteImport.update({
            id: '/industries/',path: '/industries/',getParentRoute: () => rootRouteImport
          })
const IndustriesSlugRoute = IndustriesSlugRouteImport.update({
            id: '/industries/$slug',path: '/industries/$slug',getParentRoute: () => rootRouteImport
          })
const LouisvilleKyIndexRoute = LouisvilleKyIndexRouteImport.update({
            id: '/louisville-ky/',path: '/louisville-ky/',getParentRoute: () => rootRouteImport
          })
const LouisvilleKySplatRoute = LouisvilleKySplatRouteImport.update({
            id: '/louisville-ky/$',path: '/louisville-ky/$',getParentRoute: () => rootRouteImport
          })
const PageSplatRoute = PageSplatRouteImport.update({
            id: '/page/$',path: '/page/$',getParentRoute: () => rootRouteImport
          })
const ServiceAreaIndexRoute = ServiceAreaIndexRouteImport.update({
            id: '/service-area/',path: '/service-area/',getParentRoute: () => rootRouteImport
          })
const ServiceAreaSlugRoute = ServiceAreaSlugRouteImport.update({
            id: '/service-area/$slug',path: '/service-area/$slug',getParentRoute: () => rootRouteImport
          })
const ServicesSplatRoute = ServicesSplatRouteImport.update({
            id: '/services/$',path: '/services/$',getParentRoute: () => rootRouteImport
          })
const StadiumLightingIndexRoute = StadiumLightingIndexRouteImport.update({
            id: '/stadium-lighting/',path: '/stadium-lighting/',getParentRoute: () => rootRouteImport
          })
const StadiumLightingSlugRoute = StadiumLightingSlugRouteImport.update({
            id: '/stadium-lighting/$slug',path: '/stadium-lighting/$slug',getParentRoute: () => rootRouteImport
          })
const StadiumSportsLightingIndexRoute = StadiumSportsLightingIndexRouteImport.update({
            id: '/stadium-sports-lighting/',path: '/stadium-sports-lighting/',getParentRoute: () => rootRouteImport
          })
const StadiumSportsLightingSlugRoute = StadiumSportsLightingSlugRouteImport.update({
            id: '/stadium-sports-lighting/$slug',path: '/stadium-sports-lighting/$slug',getParentRoute: () => rootRouteImport
          })
const TagSplatRoute = TagSplatRouteImport.update({
            id: '/tag/$',path: '/tag/$',getParentRoute: () => rootRouteImport
          })
const WpAdminSplatRoute = WpAdminSplatRouteImport.update({
            id: '/wp-admin/$',path: '/wp-admin/$',getParentRoute: () => rootRouteImport
          })
const WpContentSplatRoute = WpContentSplatRouteImport.update({
            id: '/wp-content/$',path: '/wp-content/$',getParentRoute: () => rootRouteImport
          })
const WpIncludesSplatRoute = WpIncludesSplatRouteImport.update({
            id: '/wp-includes/$',path: '/wp-includes/$',getParentRoute: () => rootRouteImport
          })
const WpJsonSplatRoute = WpJsonSplatRouteImport.update({
            id: '/wp-json/$',path: '/wp-json/$',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutHadleyEnergySolutionsRoute: AboutHadleyEnergySolutionsRoute,AboutUsRoute: AboutUsRoute,CommercialElectricalRoute: CommercialElectricalRoute,CommercialElectricalServicesRoute: CommercialElectricalServicesRoute,CommercialHvacRoute: CommercialHvacRoute,ContactRoute: ContactRoute,ContactUsRoute: ContactUsRoute,EnergyAuditRoute: EnergyAuditRoute,HvacMaintenanceRoute: HvacMaintenanceRoute,HvacMaintenanceLouisvilleKyRoute: HvacMaintenanceLouisvilleKyRoute,PortfolioRoute: PortfolioRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,RequestEstimateRoute: RequestEstimateRoute,ReviewsRoute: ReviewsRoute,SamplePageRoute: SamplePageRoute,ServiceAreasRoute: ServiceAreasRoute,SitemapRoute: SitemapRoute,XmlrpcDotphpRoute: XmlrpcDotphpRoute,R2023SplatRoute: R2023SplatRoute,AboutCareersRoute: AboutCareersRoute,AboutFaqRoute: AboutFaqRoute,AboutSafetyRoute: AboutSafetyRoute,AdminCallReportRoute: AdminCallReportRoute,AdminCompetitorsRoute: AdminCompetitorsRoute,AdminDashboardRoute: AdminDashboardRoute,AdminForgotPasswordRoute: AdminForgotPasswordRoute,AdminLeadsRoute: AdminLeadsRoute,AdminProjectsRoute: AdminProjectsRoute,AdminSeoRoute: AdminSeoRoute,AdminSettingsRoute: AdminSettingsRoute,AdminSignupRoute: AdminSignupRoute,AdminSpamDebugRoute: AdminSpamDebugRoute,AdminSpamVariantsRoute: AdminSpamVariantsRoute,AdminTrafficRoute: AdminTrafficRoute,AdminUsersRoute: AdminUsersRoute,AuthorSplatRoute: AuthorSplatRoute,BlogSlugRoute: BlogSlugRoute,CategorySplatRoute: CategorySplatRoute,ElectricalServicesSlugRoute: ElectricalServicesSlugRoute,EnergyManagementSlugRoute: EnergyManagementSlugRoute,FeedSplatRoute: FeedSplatRoute,GuideSlugRoute: GuideSlugRoute,HvacServicesSlugRoute: HvacServicesSlugRoute,IndustriesSlugRoute: IndustriesSlugRoute,LouisvilleKySplatRoute: LouisvilleKySplatRoute,PageSplatRoute: PageSplatRoute,ServiceAreaSlugRoute: ServiceAreaSlugRoute,ServicesSplatRoute: ServicesSplatRoute,StadiumLightingSlugRoute: StadiumLightingSlugRoute,StadiumSportsLightingSlugRoute: StadiumSportsLightingSlugRoute,TagSplatRoute: TagSplatRoute,WpAdminSplatRoute: WpAdminSplatRoute,WpContentSplatRoute: WpContentSplatRoute,WpIncludesSplatRoute: WpIncludesSplatRoute,WpJsonSplatRoute: WpJsonSplatRoute,AboutIndexRoute: AboutIndexRoute,AdminIndexRoute: AdminIndexRoute,BlogIndexRoute: BlogIndexRoute,ElectricalServicesIndexRoute: ElectricalServicesIndexRoute,EnergyManagementIndexRoute: EnergyManagementIndexRoute,FeedIndexRoute: FeedIndexRoute,HvacServicesIndexRoute: HvacServicesIndexRoute,IndustriesIndexRoute: IndustriesIndexRoute,LouisvilleKyIndexRoute: LouisvilleKyIndexRoute,ServiceAreaIndexRoute: ServiceAreaIndexRoute,StadiumLightingIndexRoute: StadiumLightingIndexRoute,StadiumSportsLightingIndexRoute: StadiumSportsLightingIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)